
import { defineComponent, createApp, toRefs, reactive, onMounted } from "vue";
import { QI_LIU_YUN_APPID } from "@/utils/util";
import { Toast } from "vant";
import {
  getMyData,
  areaList,
  AreaByCityCodeList,
  getfindVillageList,
  uploadImg,
} from "../../../../api/user";
import { saveFarmerInfo } from "../../../../api/farmer";
import { stateType, stateForm, educationList } from "./myInfo";
import { dateFormat } from "@/utils/util";
import { directUploadFile, previewImage } from "@/utils/util";
import { getConfigWeixin } from "@/utils/index";
import { useRouter,useRoute } from "vue-router";
import wx from "weixin-js-sdk";
import { getLocationApi ,getFileToken} from "../../../../api/user";
const TencentMap = (window as any).TMap;
const states = {
  lat: 0,
  lng: 0,
  id: 0,
  selectInitDate: new Date(), //初始时间
  minDate: new Date(1900, 1, 1), //日期最小值
  maxDate: new Date(
    dateFormat(new Date().getTime()).YYYY,
    +dateFormat(new Date().getTime()).MM - 1,
    +dateFormat(new Date().getTime()).DD
  ), //日期最大值
  nationList: [
    "汉族",
    "蒙古族",
    "回族",
    "藏族",
    "维吾尔族",
    "苗族",
    "彝族",
    "壮族",
    "布依族",
    "朝鲜族",
    "满族",
    "侗族",
    "瑶族",
    "白族",
    "土家族",
    "哈尼族",
    "哈萨克族",
    "傣族",
    "黎族",
    "傈僳族",
    "佤族",
    "畲族",
    "高山族",
    "拉祜族",
    "水族",
    "东乡族",
    "纳西族",
    "景颇族",
    "柯尔克孜族",
    "土族",
    "达翰尔族",
    "么佬族",
    "羌族",
    "布朗族",
    "撒拉族",
    "毛南族",
    "仡佬族",
    "锡伯族",
    "阿昌族",
    "普米族",
    "塔吉克族",
    "怒族",
    "乌孜别克族",
    "俄罗斯族",
    "鄂温克族",
    "德昂族",
    "保安族",
    "裕固族",
    "京族",
    "塔塔尔族",
    "独龙族",
    "鄂伦春族",
    "赫哲族",
    "门巴族",
    "珞巴族",
    "基诺族",
  ], //民族列表
  areaAllList: [], //地区列表
  ruralList: [], //街道列表
  ruralList2: [], //乡村列表
  fieldNames: {
    text: "areaName",
    value: "areaId",
    children: "values",
  },
  showPicker: false, //日期开关
  showSex: false, //性别开关
  showCulture: false, //文化程度开关
  showNation: false, //民族开关
  showLocation: false, //地区开关
  showRural: false, //乡村开关
  showRural2: false, //乡村开关
  areaCode: "",
  headImg: [], //头像
  defaultEducationIndex: 0,
  defaultSexIndex: 0,
  defaultNationIndex: 0,
  defaultStreet1Index: 0,
  defaultStreet2Index: 0,
  router: {},
  avatar: "",
  showMap: false,
  route:{}
};
const formInfo = {
  username: "", //姓名
  IDcard: "", //身份证
  nation: "", //民族
  sex: "", //性别
  birth: "", //出生日期
  Culture: "", //文化程度
  family: "", //家庭人口
  phone: "", //手机号
  wxnumber: "", //微信号
  location: "", //地区
  rural: "", //乡村
  detailLocation: "", //详细地址
  zhNumber: "", //账户号
  khh: "", //开户行
  bankNumber: "", //银行账号
  provinceStrName: "", //省
  cityStrName: "", //市
  areaStrName: "", //县
  addressId: {
    village: "",
    villageStrName: "",
    street: "",
    streetStrName: "",
    provinceId: 0,
    provinceStrName: "",
    cityId: 0,
    cityStrName: "",
    areaId: 0,
    areaStrName: "",
    streetid: "",
  }, //地址id
};

export default defineComponent({
  setup() {
    const state = reactive<stateType>(states);
    const fromState = reactive<stateForm>(formInfo);
    state.router = useRouter();
    state.route = useRoute()
    const {
      showMapFn,
      onSubmit,
      afterRead,
      onConfirmInitDate,
      onConfirmSex,
      onConfirmCulture,
      onConfirmNation,
      delHeadIcon,
      getLocation,
      onConfirmLocation,
      onConfirmRural,
      onConfirmRural2,
      onCancelRural2,
      initMap,
      allright,
      cancel,
      imageUploadAfter,
      onDeleteImg,
      onClickImgPoster,
    } = useEvent(state, fromState);
    const { getInfo, getRural2 } = useData(state, fromState);
    onMounted(() => {
      getInfo();
      getLocation();
    });
    return {
      ...toRefs(state),
      ...toRefs(fromState),
      onClickImgPoster,
      onDeleteImg,
      imageUploadAfter,
      cancel,
      allright,
      initMap,
      showMapFn,
      onSubmit,
      afterRead,
      onConfirmInitDate,
      onConfirmSex,
      onConfirmCulture,
      onConfirmNation,
      onConfirmLocation,
      onConfirmRural,
      educationList,
      onConfirmRural2,
      delHeadIcon,
      getLocation,
      onCancelRural2,
      getInfo,
      getRural2,
    };
  },
});
const useData = (state: stateType, fromState: stateForm) => {
  const getInfo = async () => {
    const result: any = await getMyData();
    const { village, street, provinceId, cityId, areaId } = result.data.data;
    state.id = result.data.data.id;
    fromState.username = result.data.data.farmerName;
    fromState.birth = result.data.data.birthday;
    fromState.IDcard = result.data.data.cardId;
    fromState.sex = result.data.data.sex == 1 ? "男" : "女";
    state.defaultSexIndex = result.data.data.sex == 1 ? 0 : 1;
    fromState.Culture = result.data.data.education;
    state.defaultEducationIndex = educationList.findIndex((item: any) => {
      return item.text == fromState.Culture;
    });
    state.selectInitDate = new Date(result.data.data.birthday);
    fromState.nation = result.data.data.nation;
    state.defaultNationIndex = state.nationList.findIndex((item: any) => {
      return item == fromState.nation;
    });
    fromState.family = result.data.data.population;
    fromState.phone = result.data.data.phoneNumber;
    fromState.family = result.data.data.population;
    fromState.khh = result.data.data.bankName;
    fromState.location =
      result.data.data.provinceStrName +
      "/" +
      result.data.data.cityStrName +
      "/" +
      result.data.data.areaStrName;
    fromState.detailLocation = result.data.data.addressInfo;
    fromState.rural =
      result.data.data.streetStrName + "/" + result.data.data.villageStrName;
    fromState.wxnumber = result.data.data.wxNumber;
    fromState.zhNumber = result.data.data.account;
    fromState.bankNumber = result.data.data.bankNumber;
    fromState.addressId.provinceStrName = result.data.data.provinceStrName;
    fromState.addressId.cityStrName = result.data.data.cityStrName;
    fromState.addressId.areaStrName = result.data.data.areaStrName;
    fromState.addressId = {
      ...fromState.addressId,
      village,
      street,
      provinceId,
      cityId,
      areaId,
    };
    getArea();
    if (result.data.data.imgs.length != 0) {
        state.headImg = result.data.data.imgs.map((item: any, index: number) => {
          item.tempIndex = index;
          item.progress = 100
          item.poster = item.url
          return item;
        });
    } else {
      state.headImg = [];
    }
  };
  const getArea = async () => {
    const result: any = await areaList();
    state.areaAllList = result.data.data;
    state.areaAllList.forEach((item: any) => {
      if (item.areaId === fromState.addressId.provinceId) {
        item.values.forEach((city: any) => {
          if (city.areaId == fromState.addressId.cityId) {
            city.values.forEach((area: any) => {
              if (area.areaId == fromState.addressId.areaId) {
                state.areaCode = area.areaId;
              }
            });
          }
        });
      }
    });
    AreaByCityCodeList({ areaCode: state.areaCode }).then((res: any) => {
      state.ruralList = res.data.data;
      state.defaultStreet1Index = res.data.data.findIndex((item: any) => {
        return item.streetid == fromState.addressId.street;
      });
    });
    getRural2();
  };
  const getRural2 = async () => {
    const result: any = await getfindVillageList({
      streetCode: fromState.addressId.streetid,
    });
    state.ruralList2 = result.data.data;
    state.defaultStreet2Index = result.data.data.findIndex((item: any) => {
      return item.villageid == fromState.addressId.village;
    });
  };
  return {
    getInfo,
    getRural2,
  };
};
const useEvent = (state: stateType, fromState: stateForm) => {
  const eventState = {
    map: {} as any,
    markerLayer: {} as any,
  };
  const onClickImgPoster = (item: any) => {
    previewImage(
      state.headImg.map((item: any) => item.poster),
      item.index
    );
  };
  const onDeleteImg = (item: any) => {
    state.headImg=[];
  };
  const imageUploadAfter = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 0,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          // 执行该函数后，获取数据请直接从双向绑定的数组中取值.
          directUploadFile(item, result.data);
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 0,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data);
      }
    }
  };
  const allright = () => {
    state.showMap = false;
    getLocationApi(state.lat, state.lng).then((res: any) => {
      console.log(res);
      fromState.rural = '请选择'
      let str = `${res.data.data.provinceName}/${res.data.data.cityName}/${res.data.data.areaName}`;
      fromState.location = str;
      fromState.addressId.provinceId = res.data.data.provinceCode;
      fromState.addressId.provinceStrName = res.data.data.provinceName;
      fromState.addressId.cityId = res.data.data.cityCode;
      fromState.addressId.cityStrName = res.data.data.cityName;
      fromState.addressId.areaId = res.data.data.areaCode;
      fromState.addressId.areaStrName = res.data.data.areaName;
      console.log( res.data.data.address);
      
      fromState.detailLocation = res.data.data.address
      AreaByCityCodeList({ areaCode: res.data.data.areaCode }).then(
        (res: any) => {
          state.ruralList = res.data.data;
        }
      );
    });
  };
  const cancel = () => {
    state.showMap = false;
  };
  const { getRural2 } = useData(state, fromState);
  //地图初始化函数，本例取名为init，开发者可根据实际情况定义
  const initMap = (lat: number, lng: number) => {
    //定义地图中心点坐标
    var center = new TencentMap.LatLng(lat, lng);
    //定义map变量，调用 TMap.Map() 构造函数创建地图
    eventState.map = new TencentMap.Map(document.getElementById("container"), {
      center: center, //设置地图中心点坐标
      zoom: 17, //设置地图缩放级别
      rotation: 45, //设置地图旋转角度
    });
    //Map实例创建后，通过on方法绑定点击事件
    eventState.map.on("click", clickHandler);
    //创建并初始化MultiMarker
    eventState.markerLayer = new TencentMap.MultiMarker({
      map: eventState.map, //指定地图容器
      //样式定义
      styles: {
        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
        myStyle: new TencentMap.MarkerStyle({
          width: 25, // 点标记样式宽度（像素）
          height: 35, // 点标记样式高度（像素）
          //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
          anchor: { x: 16, y: 32 },
        }),
      },
    });
  };
  //定义事件处理方法
  const clickHandler = (evt: any) => {
    eventState.markerLayer.setGeometries([]);
    state.lat = evt.latLng.getLat().toFixed(6);
    state.lng = evt.latLng.getLng().toFixed(6);
    console.log(evt, "evt");

    eventState.markerLayer.add([
      {
        id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
        styleId: "myStyle", //指定样式id
        position: new TencentMap.LatLng(state.lat, state.lng), //点标记坐标位置
        properties: {
          //自定义属性
          title: "marker1",
        },
      },
    ]);
    
    console.log("您点击的的坐标是：" + state.lat + "," + state.lng);
  };
  // 选择出生日期
  const onConfirmInitDate = (e: any) => {
    const tempDate = dateFormat(e);
    state.showPicker = false;
    fromState.birth = tempDate.YYYY + "-" + tempDate.MM + "-" + tempDate.DD;
  };
  // 选择民族
  const onConfirmNation = (value: any, index: number) => {
    state.showNation = false;
    fromState.nation = value;
  };
  // 选择性别
  const onConfirmSex = (value: any, index: number) => {
    state.showSex = false;
    fromState.sex = value;
  };
  // 选择地区
  const onConfirmLocation = (value: any) => {
    state.showLocation = false;
    let str = "",
      aId = "";
    value.selectedOptions.forEach((option: any, index: number) => {
      if (index == 0) {
        fromState.addressId.provinceId = option.id;
        fromState.addressId.provinceStrName = option.areaName;
      } else if (index == 1) {
        fromState.addressId.cityId = option.id;
        fromState.addressId.cityStrName = option.areaName;
      } else {
        fromState.addressId.areaId = option.id;
        fromState.addressId.areaStrName = option.areaName;
        aId = option.areaId;
      }
      str += "/" + option.areaName;
      fromState.rural = "";
      fromState.detailLocation = "";
    });
    fromState.location = str.substr(1);

    AreaByCityCodeList({ areaCode: aId }).then((res: any) => {
      state.ruralList = res.data.data;
    });
  };
  // 选择办事处
  const onConfirmRural = (value: any) => {
    state.showRural = false;
    state.showRural2 = true;
    fromState.addressId.streetid = value.streetid;
    fromState.addressId.street = value.streetid;
    fromState.rural = value.street;
    fromState.addressId.streetStrName = value.street;
    getRural2();
  };
  //选择乡村
  const onConfirmRural2 = (value: any) => {
    state.showRural2 = false;
    fromState.rural += "/" + value.village;
    fromState.addressId.villageStrName = value.village;
    fromState.addressId.village = value.villageid;
  };
  // 取消乡村选择
  const onCancelRural2 = () => {
    Toast({
      message: "请确认选择内容",
    });
    return false;
  };
  // 选择文化程度
  const onConfirmCulture = (value: any, index: number) => {
    state.showCulture = false;
    fromState.Culture = value;
  };
  // 提交
  const onSubmit = (values: any) => {
    let sex = fromState.sex == "男" ? 1 : 2;
    let obj = {
      ...values,
      ...fromState.addressId,
      sex,
      id: state.id,
    };
    state.headImg[0]?obj.headImgId = state.headImg[0].id:''
    if(obj.rural=='请选择' || !obj.rural){
      Toast({
        message: '请选择乡村',
      });
      return
    }
    saveFarmerInfo(obj).then((res: any) => {
      Toast({
        message: res.data.msg,
      });
      state.route.params.update = true
      state.router.back();
    });
  };
  // 删除图片
  const delHeadIcon = (file: any, detail: any) => {
    state.headImg = [];
  };
  //上传图片前
  const afterRead = async (file: any) => {
    file.status = "uploading";
    file.message = "上传中...";
    const form = new FormData();
    form.append("appid", QI_LIU_YUN_APPID);
    form.append("uploadFile", file.file);
    const result: any = await uploadImg(form);
    if (result.data.code == 0) {
      file.status = "success";
      file.message = "上传成功";
      state.avatar = result.data.data;
    } else {
      file.status = "failed";
      file.message = "上传成功";
    }
  };
  //获取位置
  const getLocation = () => {
    getConfigWeixin(["getLocation"]);
    //执行方法
    wx.ready(function () {
      wx.getLocation({
        success: function (res: any) {
          console.log(res); //返回的参数
          state.lat = res.latitude; //纬度，浮点数，范围为90 ~ -90
          state.lng = res.longitude; //经度，浮点数，范围为180 ~ -180。

          initMap(state.lat, state.lng);
        },
        fail: function (res: any) {
          console.log("获取位置失败");
        },
      });
    });
  };
  const showMapFn = () => {
    state.showMap = true;
  };
  return {
    onClickImgPoster,
    onDeleteImg,
    imageUploadAfter,
    allright,
    cancel,
    showMapFn,
    initMap,
    onSubmit,
    afterRead,
    onConfirmInitDate,
    onConfirmSex,
    onConfirmCulture,
    onConfirmNation,
    onConfirmLocation,
    onConfirmRural,
    onConfirmRural2,
    delHeadIcon,
    onCancelRural2,
    getLocation,
  };
};
